import { Box, Container, Link as MuiLink, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import Logo from "../../assets/images/logoBCT.png"; // ✅ white logo version
import { useLocationContext } from "../../context/LocationContext";
import ShareActions from "./ShareActions";

const Footer = () => {
  const { city, setCity } = useLocationContext();
  const categories = [
    { label: "Temple", icon: "🛕", slug: "Mandir" },
    { label: "Hospital", icon: "🏥", slug: "hospital" },
    { label: "Water Park", icon: "🎢", slug: "waterpark" },
    { label: "Restaurant", icon: "🍽", slug: "restaurant" },
    { label: "Mall", icon: "🛍", slug: "mall" },
    { label: "Park", icon: "🌳", slug: "citypark" },
  ];

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#0D3B66", // Neon
        color: "#FAF0CA",
        pt: { xs: 5, md: 7 },
        pb: 3,
        position: "relative",
      }}
    >
      <Container>
        {/* ===== TOP GRID ===== */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: { xs: 4, md: 6 },
            justifyContent: "space-between",
          }}
        >
          {/* ===== BRAND ===== */}
          <Box sx={{ maxWidth: 360 }}>
            <Box
              component="img"
              src={Logo}
              alt="NearbyGuide"
              sx={{
                height: 34,
                mb: 2,
              }}
            />

            <Typography
              sx={{
                color: "rgba(250,240,202,0.85)",
                fontSize: "0.95rem",
                lineHeight: 1.7,
              }}
            >
              NearbyGuide helps you discover trusted places near you — temples,
              hospitals, parks, malls and essential services across cities.
            </Typography>
          </Box>

          {/* ===== POPULAR CITIES ===== */}
          <Box>
            <Typography
              sx={{
                fontWeight: 700,
                mb: 1.5,
                color: "#FFFFFF",
              }}
            >
              Popular Cities
            </Typography>

            {["Lucknow", "Delhi", "Mumbai", "Kanpur", "Pune"].map((city) => (
              <Typography
                key={city}
                component={Link}
                to={`/city/${city.toLowerCase()}`}
                sx={{
                  display: "block",
                  color: "rgba(250,240,202,0.85)",
                  fontSize: "0.9rem",
                  mb: 0.8,
                  textDecoration: "none",
                  "&:hover": {
                    color: "#F4D35E",
                  },
                }}
              >
                {city}
              </Typography>
            ))}
          </Box>

          {/* ===== CATEGORIES ===== */}
          <Box>
            <Typography
              sx={{
                fontWeight: 700,
                mb: 1.5,
                color: "#FFFFFF",
              }}
            >
              Categories
            </Typography>

            {categories?.map((cat) => (
              <Typography
                key={cat?.slug}
                component={Link}
                to={`/city/${city.toLowerCase()}/${cat?.slug?.toLowerCase()}`}
                sx={{
                  display: "block",
                  color: "rgba(250,240,202,0.85)",
                  fontSize: "0.9rem",
                  mb: 0.8,
                  textDecoration: "none",
                  "&:hover": {
                    color: "#F4D35E",
                  },
                }}
              >
                {cat?.label}
              </Typography>
            ))}
          </Box>
        </Box>

        {/* ===== DIVIDER ===== */}
        <Box
          sx={{
            my: 4,
            height: 1,
            background:
              "linear-gradient(90deg, transparent, rgba(250,240,202,0.25), transparent)",
          }}
        />

        {/* ===== BOTTOM BAR ===== */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 2,
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: "0.85rem",
              color: "rgba(250,240,202,0.75)",
            }}
          >
            © {new Date().getFullYear()} NearbyGuide. All rights reserved.
          </Typography>

          <Typography
            sx={{
              fontSize: "0.85rem",
              color: "rgba(250,240,202,0.75)",
            }}
          >
            Powered by{" "}
            <MuiLink
              href="https://oglitz.com"
              target="_blank"
              rel="noopener"
              sx={{
                color: "#F4D35E",
                fontWeight: 600,
                textDecoration: "none",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
            >
              Oglitz Software Pvt. Ltd.
            </MuiLink>
          </Typography>
        </Box>
      </Container>
      <ShareActions
        title="NearbyGuide – Discover Trusted Places Near You"
        text="NearbyGuide helps you find trusted places, services and attractions across cities."
      />
    </Box>
  );
};

export default Footer;
